<template>
    <div style="padding-top: 50px;">
        <div class="ps-about" v-if="!isLoading">
            <div class="container">
                <breadcrumb :dataList="breadcrumb"/>
            </div>
            <div class="ps-about__content">
                <div class="container">
                    <h1 class="ps-blog__title">Kataloqlar</h1>
                </div>
                <div class="container">

                    <div class="row">

                        <div class="col-6 col-md-3 mb-5" v-for="b in catalogList" :key="b.id">
                            <a :href="b.link" target="_blank">
                                <img :src="`${baseUrl}/photo.php?w=400&h=560&zc=2&src=${b.photo}`" alt=""
                                     class="img-thumbnail img-fluid"></a>
                        </div>

                    </div>


                </div>


            </div>
        </div>
        <div v-else>
            <div class="container">Loading...</div>
        </div>
    </div>
</template>

<script>

    import Breadcrumb from "../layout/page/Breadcrumb";
    import {getBlocks} from "../../repositories/GeneralDataRepository";
    import {mapState} from "vuex";
    import {baseUrl} from "../../repositories/Repository";

    export default {
        name: "Catalogs",
        components: {Breadcrumb},
        data() {

            return {
                baseUrl: baseUrl,
                isLoading: true,
                breadcrumb: [],
                catalogList: []
            };

        },
        computed: {
            ...mapState({
                languageCode: state => state.app.languageCode
            })
        },
        watch: {
            '$route'() {
                this.loadData();
            }
        },
        methods: {
            async loadData() {

                this.isLoading = true;
                this.$store.commit('app/setLoading', true);
                await getBlocks(this.languageCode, 'catalog', false).then(data => {

                    this.catalogList = data;
                    this.breadcrumb = [
                        {
                            url: '/',
                            text: 'Əsas səhifə'
                        },
                        {
                            url: 'catalogs',
                            extraClass: 'active',
                            text: "Kataloqlar"
                        }
                    ];
                    this.isLoading = false;
                })

                this.$store.commit('app/setLoading', false);

            }
        },

        async mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>

</style>